import React from 'react'
import IconDots from '../../../assets/dots.png'
import ArrowNext from '../../../assets/arrowNext.png'
import IconPencil from '../../../assets/pencil-01.png'
import { ButtonDropdown } from 'components/molecules/ButtonDropdown/ButtonDropdown'
import IconTrash from '../../../assets/trash.png'
import AppModalConfirmation from 'components/atoms/AppModalConfirmation/AppModalConfirmation'
import { useState } from 'react'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'
import { OPERATION_MODE_CODES } from '../../../core/domain/operationModeConstants'
import { OperationMode } from '../../../core/domain/operationMode'
import { OperationModeBadge } from '../../../core/presentation/components/molecules/OperationModeBadge/OperationModeBadge'

interface Props {
    id: number
    title: string
    countRules: number
    countChutes: number
    nameWarehouse?: string
    operationMode?: OperationMode
    onSubmit?: () => void
    deletePattern: () => void
    editPattern: () => void
}

export default function PatternCardItem({
    id,
    title,
    countRules,
    countChutes,
    onSubmit,
    deletePattern,
    editPattern,
    nameWarehouse,
    operationMode,
}: Props) {
    const [confirmModal, setConfirmModal] = useState(false)
    const { can } = usePermissions()

    const handleDeletePattern = () => {
        setConfirmModal(false)
        deletePattern()
    }

    const canEdit = can(RolePermissions.templates.edit)
    const canDelete = can(RolePermissions.templates.delete)

    const dropdownOptions = [
        ...(canDelete ? [{ title: 'Eliminar', icon: IconTrash, onClick: () => setConfirmModal(true) }] : []),
        ...(canEdit ? [{ title: 'Editar', icon: IconPencil, onClick: () => editPattern() }] : []),
    ]

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if ((e.key === 'Enter' || e.key === ' ') && !confirmModal && onSubmit) {
            e.preventDefault()
            onSubmit()
        }
    }

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={(e) => {
                if (!confirmModal && onSubmit) {
                    onSubmit()
                } else {
                    e.stopPropagation()
                    setConfirmModal(false)
                }
            }}
            onKeyDown={handleKeyDown}
            aria-label={`Plantilla ${title}`}
            className="w-full border border-[#CBD5E1] hover:border-[#1F2531] cursor-pointer transition-colors duration-200 flex justify-between items-center px-4 py-4 bg-white rounded-xl mb-4"
        >
            <AppModalConfirmation
                title={'Eliminar Plantilla ' + id}
                description="¿Estás seguro de que deseas eliminar esta plantilla? Esta acción no se puede deshacer."
                onClose={() => setConfirmModal(false)}
                handleConfirm={handleDeletePattern}
                isOpen={confirmModal}
            />
            <div className="text-left">
                <div className="flex items-center">
                    <p className="font-semibold text-base text-[#141A1F]">{title}</p>
                    <div className="ml-5" onClick={(e) => e.stopPropagation()}>
                        {dropdownOptions.length > 0 && (
                            <ButtonDropdown options={dropdownOptions} color="primary" imageSrc={IconDots} />
                        )}
                    </div>
                </div>
                <div className="flex items-center mt-1 gap-3">
                    <span className="text-sm font-normal text-[#3E5060]">{countRules} reglas</span>
                    {operationMode?.code === OPERATION_MODE_CODES.SORTER && (
                        <>
                            <div className="w-px h-4 bg-gray-300" aria-hidden="true" />
                            <span className="text-sm font-normal text-[#3E5060]">{countChutes} chutes asignados</span>
                        </>
                    )}
                    {nameWarehouse && (
                        <>
                            <div className="w-px h-4 bg-gray-300" aria-hidden="true" />
                            <span className="text-sm font-normal text-[#3E5060]">Warehouse: {nameWarehouse}</span>
                        </>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-3">
                {operationMode && <OperationModeBadge operationMode={operationMode} />}
                <img src={ArrowNext} alt="" aria-hidden="true" />
            </div>
        </div>
    )
}
